module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators-2.a07bc51a.jpg";